var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailVerification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 63,
    viewBox: "0 0 87 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.32496C0 1.93635 1.94569 0 4.34581 0H91.6097C94.0099 0 95.9555 1.93635 95.9555 4.32496V69.675C95.9555 72.0637 94.0099 74 91.6097 74H4.34581C1.94569 74 0 72.0637 0 69.675V4.32496ZM8.69162 8.64992V65.3501H87.2639V8.64992H8.69162Z",
    fill: "#0F20E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.2779 9.42123C96.6024 11.4132 96.0534 14.0966 94.0518 15.4147L50.3764 44.1758C48.9218 45.1337 47.0327 45.1332 45.5785 44.1747L1.9465 15.4136C-0.0545053 14.0946 -0.602214 11.411 0.723154 9.41958C2.04852 7.42818 4.74508 6.8831 6.74608 8.20211L47.9795 35.3821L89.2556 8.20101C91.2572 6.88292 93.9535 7.42923 95.2779 9.42123Z",
    fill: "#0F20E8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailVerification);
export default __webpack_public_path__ + "static/media/email_verification.ded47ee08371294edf09a51bcfe0b132.svg";
export { ForwardRef as ReactComponent };